export default {
  'booking.exporter': 'Exporter',
  'booking.issueDate': 'Issue date',
  'booking.email': 'Email',
  'booking.PassengerNameInEnglish': 'Passenger name in English',
  'booking.PassengerLastNameInEnglish': 'last name in English',
  'booking.NationalityOfThePassenger': 'Nationality of passenger',
  'booking.genderOfThePassenger': 'Gender of passenger',
  'booking.LoginToAccount': 'Login to account',
  'booking.userGoForCreateAccount':
    "If you don't have an account, create an account now and take advantage of the many benefits of the Tripsi customer club.",
  'booking.continuWithGuestUser':
    'If you continue as a guest user, you will not benefit from the customer club privileges.',
  'booking.totalsales': 'Total Sales By Counter',
  'booking.FirstPassenger': 'first passenger',
  'booking.totalpriceofpassengers': ' Total price of passenger ',
  'booking.ticketPriceDetails': 'Ticket Price details',
  'booking.toViewTheListOfPreviousPassengers':
    'To view the list of previous passengers',
  'booking.pleaselogin': 'please',
  'booking.travelerdetails': 'Traveler details ',
  'booking.buy_ticket': 'Buy Ticket',
  'booking.wheretogo': 'Where would like to go ?',
  'booking.searchflight': 'Search Flight',
  'booking.selectflight': 'Select Flight',
  'booking.oneway': 'One way',
  'booking.onewaytrip': 'One Way',
  'booking.roundtrip': 'Round trip',
  'booking.multicity': 'Multi city',
  'booking.bestguarantee': 'Best Fares  Guaranteed online',
  'booking.getdeals': 'Get Deals',
  'booking.signupnow': 'SignUp Now',
  'booking.from': 'From',
  'booking.to': 'To',
  'booking.guest': 'Guest',
  'booking.city': 'City',
  'booking.country': 'Contry',
  'booking.Adult': 'Adult',
  'booking.adult': 'Adult',
  'booking.Child(Age 2-12)': 'Child (Age 2-12)',
  'booking.Infant(Age 0-2)': 'Infant (Age 0-2)',
  'booking.senior': 'Senior',
  'booking.senior(Over 65)': 'Senior Citizen (Over 65)',
  'booking.students': 'Students',
  'booking.students(Over 18)': 'Students (Over 18)',
  'booking.toddler': 'Toddler',
  'booking.toddler(Age 0-2)': 'Toddler in own seat',
  'booking.guestsandcities': 'Guest And Cities',
  'booking.startover': 'Start Over',
  'booking.showmoredate': 'Show More Date',
  'booking.selectdate': 'Select Date',
  'booking.date': 'Date',
  'booking.changedate': 'Change Date',
  'booking.airline': 'AirLines',
  'booking.departs': 'Departs ',
  'booking.arrives': 'Arrives',
  'booking.duration': 'Duration',
  'booking.travelclass': 'Class',
  'booking.priceperadult': 'Adult Price',
  'booking.priceperchild': 'Child Price',
  'booking.priceperinfant': 'Infant Price',
  'booking.flightnumber': 'Flight No ',
  'booking.remainseat': 'Remain Seat',
  'booking.cost': 'Cost',
  'booking.showmore': 'Show More',
  'booking.birthyear': 'Birth Year',
  'booking.birthmonth': 'Birth Month',
  'booking.birthday': 'Birth Date',
  'booking.passportno': 'Passport No',
  'booking.birthcountry': 'Birth Country',
  'booking.passportcountry': 'Nationality',
  'booking.passportexpireyear': 'Expire Year',
  'booking.passportexpiremonth': 'Expire Month',
  'booking.passportexpireday': 'Expire Day',
  'booking.completeform': 'Complete form to continue',
  'booking.changeavatar': 'change avatar',
  'booking.passengerinfo': 'Passenger Information',
  'booking.isiranian': 'Iranian',
  'booking.othernationality': 'Other Nationality',
  'booking.perviousepassenger': 'Choose from Passengers List',
  'booking.index': 'Index',
  'booking.primarytraveler': 'Primary Traveler',
  'booking.adultinformation': 'Adult Information',
  'booking.childinformation': 'Child Information',
  'booking.infantinformation': 'Infant Information',
  'booking.phone': 'Phone Number',
  'booking.totalamount': 'Total Price',
  'booking.showreserve': 'Show Reserve',
  'booking.stopcount': 'Stop',
  'booking.airplanetype': 'Airplane',
  'booking.international': 'International',
  'booking.domestic': 'Domestic',
  'booking.notexist': 'Not exist',
  'booking.noavailableflight': 'No available flights',
  'booking.departurecities': 'Departure City',
  'booking.returncities': 'Return City',
  'booking.departuredate': 'Departure Date',
  'booking.returndate': 'Return Date',
  'booking.departuretime': 'Departure Time',
  'booking.returntime': 'Return Time',
  'booking.paynow': 'Pay Now',
  'booking.sigin': 'Sign In',
  'booking.signup': 'Sign Up',
  'booking.notregister': 'Not Register',
  'booking.elevatemembers': 'Elevate Members',
  'booking.departureflightinfo': 'Departure Information',
  'booking.returnflightinfo': 'Return Information',
  'booking.previouspassenger': 'Previous Passengers',
  'booking.hi': 'Hi, ',
  'booking.travelwith': 'You Travel with',
  'booking.ticket': 'Your ticket will be issued soon',
  'booking.successpayment': 'Your payment was successful',
  'booking.previousepassengerlist': 'Previous Passenger List',
  'booking.bookingflights': 'Booking Flights',
  'booking.flightno': 'Flight No',
  'booking.child': 'Child',
  'booking.infant': 'Infant',
  'booking.male': 'Male',
  'booking.female': 'Female',
  'booking.departureflight': 'Departure Flight',
  'booking.returnflight': 'Return Flight',
  'booking.importantTips': 'ImportantTips',
  'booking.passengerArrivringTip':
    'The passenger must arrive at the airport 4 hours before the flight to complete the boarding procedures on time',
  'booking.payTextTip':
    'Pay the exit fees online through the Sadad Bank Melli portal to avoid delays at the airport',
  'booking.showticket': 'Show Tickets',
  'booking.cancel': 'Cancel',
  'booking.passengers': 'Passengers',
  'booking.price': 'Price',
  'booking.returnprice': 'Return Price',
  'booking.cancelstatus': 'Status',
  'booking.cancelreason': 'why do you want to cancel your ticket ?',
  'booking.personalproblem': 'Personal Problem (Based on Airline Rules)',
  'booking.airlineproblem': 'Cancel Flight by Airline',
  'booking.flightproblem': 'Delay or Hurry More Than 2 Hours',
  'booking.back': 'Back',
  'booking.nextstep': 'Next Step',
  'booking.previousstep': 'Previous Step',
  'booking.cancelingrules': 'Canceling Rules',
  'booking.wait': 'Please Wait  ......',
  'booking.flights': 'Flights',
  'booking.cancelpayment': 'Your Transaction Failed',
  'booking.refid': 'Your Tracking Code is: ',
  'booking.airport': 'Airports',
  'booking.flighttime': 'Flight Time',
  'booking.flightstopcount': 'Stops',
  'booking.morning': 'Morning(0 until 8)',
  'booking.noon': 'Noon(8 until 14)',
  'booking.afternoon': 'Afternoon(14 Until 20)',
  'booking.night': 'Night(After 20)',
  'booking.sort': 'Sorting',
  'booking.sortbyprice': 'By Price',
  'booking.sortbytime': 'By Time',
  'booking.sortbypoint': 'By Point',
  'booking.nonstop': 'Direct',
  'booking.onestop': 'One Stop',
  'booking.morethanonestop': 'More than one Stop',
  'booking.origin': 'Origin',
  'booking.destination': 'Destination',
  'booking.startdate': 'Start Date',
  'booking.enddate': 'End Date',
  'booking.search': 'Search',
  'booking.filter': 'Filter',
  'booking.agree': 'I Agree',
  'booking.cancelrules': 'Canceling Rules',
  'booking.flightscount': ' Flights found!',
  'booking.clearfilter': 'Clear',
  'booking.gifavatar': 'Gif Avatar',
  'booking.avatar': 'Avatar',
  'booking.notfound': 'No city was found',
  'booking.nextyear': 'Next Year',
  'booking.previousyear': 'Prev Year',
  'booking.details': 'Details',
  'booking.adultprice': 'Price Per Adult',
  'booking.sortby': 'Sort By',
  'booking.bydescendingprice': 'Price',
  'booking.byascendingprice': 'Price',
  'booking.bydescendingpoint': 'Point',
  'booking.byascendingpoint': 'Point',
  'booking.byascendingduration': 'Duration',
  'booking.bydescendingduration': 'Duration',
  'booking.bydescendingtime': 'Depart Time',
  'booking.byascendingarrivetime': 'Arrive Time',
  'booking.bydescendingarrivetime': 'Arrive Time',
  'booking.byascendingtime': 'Depart Time',
  'booking.justthis': 'Just',
  'booking.searchpassenger': 'You are looking for... ',
  'booking.edit': 'Edit',
  'booking.select': 'Select',
  'booking.gotoday': 'Go Today',
  'booking.pricedetail': 'Price Details',
  'booking.passengertype': 'Type',
  'booking.fareprice': 'Fare Price',
  'booking.tax': 'Tax',
  'booking.allairport': ' ( All Airport ) ',
  'booking.moneyunit': '(All Prices are Dollar)',
  // "booking.moneyunit": "(All Prices are Toman)",
  'booking.noseatresult': 'No seats',
  'booking.today': 'Today',
  'booking.terminal': 'Terminal',
  'booking.sumprice': 'Total Price',
  'booking.sameairport': "Please enter unique 'From' and 'To' airports.",
  'booking.stopin': 'Stop in',
  'booking.megaleapyearsale': 'Mega Leap Year Sale',
  'booking.planasunnyd1': 'Plan a sunny getaway now and save with',
  'booking.planasunnyd2': 'super rare fares 29% off.',
  'booking.restrictionsapply': 'Restrictions apply',
  'booking.grabaseat': 'GRAB A SEAT',
  'booking.enjoywithbestfriends': 'Enjoy With Best Friends',
  'booking.helpafriendd1': 'Help a friend breakup with their loyalty program',
  'booking.helpafriendd2': 'and score Elevate points',
  'booking.termsandconditionsapply': 'Terms and conditions apply',
  'booking.bookhotels': 'Book Hotels',
  'booking.booktours': 'Book Tours',
  'booking.takeofffaster': 'Take Off Faster',
  'booking.earn10kpointsd1': 'Earn 10K points with a IAM TOURIST',
  'booking.earn10kpointsd2': 'Visa Signature Card.',
  'booking.weathertoday': 'weather today',
  'booking.learnmore': 'LEARN MORE',
  'booking.swipeforthesky': 'SWIPE FOR THE SKY',
  'booking.getsetforamorerewardingexperienceonthegroundandinthesky':
    'Get set for a more rewarding experience on the ground and in the sky with the new IAM TOURIST Visa Signature® Card.',
  'booking.firstoneonfirstoneoff': 'FIRST ONE ON, FIRST ONE OFF',
  'booking.inahurry':
    'In a hurry? Make a “B” line for the car with a preferred main cabin seat towards the front of the plane, or treat yourself to priority security and boarding for a small fee.',
  'booking.feeltheupgrade': 'FEEL THE UPGRADE.',
  'booking.travelinstylewithextralegroom':
    'Travel in style with extra legroom, priority boarding and security, and more in Main Cabin Select. Live it up, way up.',
  'booking.takethefasttrack': 'TAKE THE FAST TRACK.',
  'booking.breezethroughsecuritylikeyouowntheplace':
    'Breeze through security like you own the place with TSA Pre✓™ expedited screening. Find out how to enjoy the benefits.',
  'booking.corporaterewards': 'CORPORATE REWARDS',
  'booking.abetterflighttoyournextmeetingdoesn’thavetobeanextravagance':
    'A better flight to your next meeting doesn’t have to be an extravagance. Elevate, Inc., is our corporate rewards program that gives your business a little something back for what you spend on travel.',
  'booking.packyourpoints': 'PACK YOUR POINTS.',
  'booking.livelargeat35,000feet':
    'Live large at 35,000 feet. Join Elevate and start racking up points, perks and reward flights with nobblackout dates.',
  'booking.allpassengerprice': 'Total Price For All Passengers',
  'booking.baggages': 'Baggages',
  'booking.orderdate': 'Order Date',
  'booking.traveldate': 'Travel Date',
  'booking.passengername': 'Name',
  'booking.invoice': 'Invoice',
  'booking.totalprice': 'Total price',
  'booking.cancelticket': 'CANCEL TICKET',
  'booking.operatedairline': 'Operated Airline',
  'booking.count': 'Count',
  'booking.departureflighttime': 'Departure Time',
  'booking.returnflighttime': 'Return Time',
  'booking.returnstopcount': 'Return Stops',
  'booking.pc': 'PC',
  'booking.kg': 'KG',
  'booking.cabin': 'Cabin',
  'booking.layoverairports': 'Layover Airports',
  'booking.includeairports': 'Include Airports',
  'booking.departduration': 'Depart Duration',
  'booking.returnduration': 'Return Duration',
  'booking.nightcount': 'Night',
  'booking.nights': 'Nights',
  'booking.showflightdetail': 'Show details',
  // "booking.toman": "USD",
  'booking.toman': 'IRT',
  'booking.free': 'Free',
  'booking.hour': 'Hour',
  'booking.minutes': 'Min',
  'booking.and': 'and',
  'booking.nobaggage': 'No Baggage',
  'booking.mainterminal': 'Main Terminal',
  'booking.shamsi': 'jalali',
  'booking.miladi': 'gregorian',
  'booking.adultageerror': 'Adult age should be more than 12 years old',
  'booking.seniorageerror':
    'Senior citizen age should be more than 60 years old',
  'booking.toddlerageerror': 'toodler age should be less than 2 years old',
  'booking.childageerror':
    'child age should be more than 2 and less than 12 years old',
  'booking.infantageerror': 'infant age should be less than 2 years old',
  'booking.passenger': 'Passenger',
  'booking.important': 'Important!',
  'booking.identifynote':
    'Passengers full name must be spelled in English exactly as appears on passport.',
  'booking.validpassportdate':
    'Your passport expire date should be more than 6 months.',
  'booking.adt': 'ADT',
  'booking.chd': 'CHD',
  'booking.inf': 'INF',
  'booking.passcount': 'Passenger',
  'booking.departure': 'Departure',
  'booking.return': 'Return',
  'booking.allflightinformation': 'All Flights Information',
  'booking.notavailable': 'N/A',
  'booking.previousemonth': 'Previouse',
  'booking.nextmonth': 'Next',
  'booking.passportexpiredate': 'Passport Expire Date',
  'booking.arrivein': 'Arrive in',
  'booking.nextdays': 'Next Day',
  'booking.clearallfilter': 'Clear All Filter',
  'booking.duplicatepassenger':
    'National Code or Passport Number is Duplicated',
  'booking.policy': 'I have read and agree the term of',
  'booking.changecontact': ' Ticket info will send to :',
  'booking.customeragreement': 'Customer Agreement',
  'booking.flightrules': 'Flight Rules',
  'booking.changecontacttitle': 'Change Contact Information',
  'booking.fullname': 'Full Name',
  'booking.address': 'Address',
  'booking.change': 'Change',
  'booking.firstname': 'Name',
  'booking.lastname': 'Last Name',
  'booking.departureairport': 'Dearture Airport',
  'booking.arrivalairport': 'Arrival Airport',
  'booking.previousedays': 'previouse day',
  'booking.day': 'Day',
  'booking.month': 'Month',
  'booking.year': 'Year',
  'booking.changepassenger': 'Change Passengers Count',
  'booking.editdepartcity': 'Edit Origin City',
  'booking.editdestinationcity': 'Edit Destination City',
  'booking.editdepartdate': 'Edit Origin Date',
  'booking.editdestinationdate': 'Edit Destination Date',
  'booking.changepassengernotify':
    'If you change passenger in this step you will go back to search flight step!!!!',
  'booking.edittooltip':
    'Please,Click on desired property to change flight properties ',
  'booking.books': 'BOOKS',
  'booking.reserves': 'Reserved',
  'booking.of': 'Of',
  'booking.canceled': 'Canceled',
  'booking.history': 'History',
  'booking.searchpassengerinfo':
    'Name, PassportNo, National Code, Order Number,Ticket Number, PNR',
  'booking.issued': 'Issued',
  'booking.bought': 'Issued',
  'booking.serviceType': 'Service Type',
  'booking.serviceName': 'Flight,Hotel,train ...',
  'booking.invoicenumber': 'Order No',
  'booking.chooseticket': 'Which Ticket do you want to cancel?',
  'booking.cancelreturn': 'Cancel Only Return Ticket',
  'booking.cancelroundtrip': 'Cancel All Ticket',
  'booking.addflight': 'Add Flight',
  'booking.showmulticity': 'Show All Flights',
  'booking.view': 'View',
  'booking.takeofffrom': 'Take-Off time from',
  'booking.at': 'At',
  'booking.tripsi': 'Tripsi',
  'booking.includetax': 'Price include taxes and all airline costs',
  'booking.paymentsummery': 'Payment summary',
  'booking.counter': 'Counter',
  'booking.sum': 'Sum',
  'booking.transaction': 'Transactions Report',
  'booking.countercommission': "Counter's Commission Report",
  'booking.domesticflightscount': 'Domestic Flights Count',
  'booking.internationalflightscount': 'International Flights Count',
  'booking.flightCount': 'Flights Count',
  'booking.createdate': 'Create Date',
  'booking.income': 'Income',
  'booking.notwithdrawincome': 'Not Withdraw Income',
  'booking.notwithdrawpoint': 'Remain Point',
  'booking.withdrableincome': 'Withdrable Income',
  'booking.withdrablepoint': 'Withdrable Point',
  'booking.pendingincome': 'Pending Income',
  'booking.pendingpoint': 'Pending Point',
  'booking.collectedpoint': 'Collected Point',
  'booking.spentpoint': 'Spent Point',
  'booking.paymentstatus': 'Payment Status',
  'booking.withdrawdate': 'Withdraw Date',
  'booking.countername': "Counter's Name",
  'booking.canceleditting': 'Cancel',
  'booking.nationalcode': 'National',
  'booking.previousweek': 'Prev Week',
  'booking.nextweek': 'Next Week',
  // "booking.allprice": "all prices are in Dollar",
  'booking.allprice': 'All prices are in IRT',
  'booking.allpriceisrial': 'All prices are in IRR',
  'booking.showallcalendar': 'show matrix price',
  'booking.hideallcalendar': 'hide matrix price',
  'booking.multicitytrip': 'Multi City Trip',
  'booking.selectstakeholder': 'Select Your Stakeholder',
  'booking.changestakeholder': 'Change Stakeholder',
  'booking.ticketwithoutprice': 'Ticket Without Price',
  'booking.markupticket': 'Ticket with Markup',
  'booking.orginalticket': 'Original Ticket',
  'booking.markup': 'Markup',
  'booking.removeflight': 'Remove flight',
  'booking.continueguest': 'Continue as a Guest',
  'booking.hotel': 'Hotel',
  'booking.trackorder': 'Track orders',
  'booking.trackingcode': 'Tracking Code',
  'booking.searchyourorders': 'Search your orders',
  'booking.panel': 'Panel',
  'booking.required': 'REQUIERD',
  'booking.baggagerules': 'Baggage Rules',
  'booking.userpoint': 'derik',
  'booking.notresult': 'tracking code is not valid',
  'booking.attachpassport': 'Upload passport',
  'booking.payhint':
    'Please ckeck customer agreement and flight rules  to continue',
  'booking.completecontactdescription':
    'Please complete  ticker issuer contact info.',
  'booking.updatepassenger': 'Update passenger info',
  'booking.paylater': 'pay later',
  'booking.pnr': 'PNR',
  'booking.penaltyprice': 'Penalty Price',
  'booking.sumcancelprice': 'Total refundable amount',
  'booking.paymenttype': 'Payment type',
  'booking.chargecredit': 'charge my credit',
  'booking.chargecreditinfo':
    "The amount will be charged in your Tripsi's credit  for up to 7 business days.",
  'booking.deposit': 'Deposit to bank card',
  'booking.depositinfo':
    'The amount will be deposited into the bank account from which the purchase was made up to a maximum of 7 business days.',
  'booking.cancelmessage':
    'Your cancellation request has been successfully submitted and is on the progress',
  'booking.contactus': "Contact Tripsi's support team if there is a problem",
  'booking.sendproblem': 'Send problem',
  'booking.downloadticket': 'Download Ticket',
  'booking.notrefundable': 'Not refundable',
  'booking.sendrequest': 'Send Request',
  'booking.withdrawtype': 'Withdraw Type',
  'booking.hours': 'hours',
  'booking.hour': 'hour',
  'booking.before': 'before flight',
  'booking.flight': 'flight',
  'booking.exacttime': 'at noon',
  'booking.until': 'until',
  'booking.afterflight': 'after flight',
  'booking.beforeflight': 'before flight',
  'booking.after': 'till after',
  'booking.fromhours': 'from',
  'booking.agenycommission': 'Agency commission',
  'booking.unknown': 'َUnknown',
  'booking.callsupport':
    'Error occurred  while issuing tickets, please call support.',
  'booking.searchtimeout': 'Search this flight again?',
  'booking.timeout': 'Search time ...',
  'booking.searchagaininfo': 'The time for searching this',
  'booking.searchagaininfomsg': ' flight was finished',
  'booking.searchagian': 'Yes',
  'booking.startagain': 'No',
  'booking.nocancelrules': 'Flight rule not found',
  'booking.andhigher': 'and higher',
  'booking.printticket': 'Print ticket',
  'booking.retrivedocument': 'Retrieving Document...',
  'booking.forthepassenger': 'For The Passenger',
  'booking.flightticket': 'Flight Ticket',
  'booking.ticketno': 'Ticket no',
  'booking.deptime': 'Dep Time',
  'booking.cancelterm':
    '1-Cancellation terms for CHARTER flights depend on provider rules. This means it may never be canceled.',
  'booking.cancelrulehint': '2-Cancellation costs depends on airline rules.',
  'booking.attention':
    'Attention: Passengers are required to be present at the airport 2 hour before the departure.',
  'booking.valididentify':
    '3-Please have valid identity documents such as national ID card, birth certificate or  passport with yourself..',
  'booking.online': 'Online',
  'booking.selectcountry': 'Select Country',
  'booking.calendar': 'Calendar',
  'booking.countercommissionreport': 'Counter Commission Report',
  'booking.hasusername': 'Do you have user name ?',
  'booking.nousername': "Don't have user name ?",
  'booking.signuporguest': '(Signup or Guest user)',
  'booking.guestuser': 'Guest user',
  'booking.notuserbefore': 'Create an account',
  'booking.reservationfail': 'It is not possible to book this flight',
  'booking.reservationerror': 'Reservation Failure !',
  'booking.passengererror': 'Passangers Information Error ! ',
  'booking.passengerInformationHint':
    'Please check passengers informations....',
  'booking.displayticket': 'How to display tickets',
  'booking.selectcustomer': 'Select Customer',
  'booking.asacustomer': 'Assign Customer',
  'booking.changeticketprice': 'Change Ticket Price View',
  'booking.save': 'Save',
  'booking.fromwallet': 'Wallet',
  'booking.fromcredit': 'Credit',
  'booking.frompoint': 'Point',
  'booking.usederik': 'Pay ticket price with your derik',
  'booking.yourderik': 'Your Derik : ',
  'booking.equivalentprice': 'Equivalent Price : ',
  'booking.bookinginvoiceno': 'Booking Invoice Number',
  'booking.importpnr': 'Import PNR',
  'booking.pnrhint': 'select your system',
  'booking.pnrsteps': 'To use PNR, please do these steps: ',
  'booking.enteryour': '1 - Enter to your Amadeus panel',

  'booking.openreference': '2 - Make your reservation in Amadeus panel. ',
  'booking.pnr3': '3 - Enter the passenger passport information completely. ',
  'booking.entercommand':
    '4 - Enter the following command code and then press enter key. ',
  'booking.savepnr': '5 - Save your PNR and press enter key. ',
  'booking.pnr6':
    '6 - In Tripsi page, enter your PNR number in the reference number section. ',
  'booking.pnr7': '7 - In the Passenger Last Name field, enter it. ',
  'booking.pnr8': '8 - Click the booking button. ',
  'booking.pnr9': '9 - Go to the payment page after checking the information. ',
  'booking.pnr10': '10 - Your ticket has been issued. ',

  'booking.laststep':
    'Now, you can enter your reference in the box below and follow the export steps. ',
  'booking.leadlastname': 'Passenger last name',
  'booking.usepnr': 'Import PNR and view',
  'booking.buyer': 'Buyer',
  'booking.pnrnotfound': 'No items found',
  'booking.uploadpassporterror': 'Passport information is not legible',
  'booking.servererror': 'The server has a problem.',
  'booking.accessdenied': 'Access denied',
  'booking.newpassenger': 'Add new Passenger',
  'booking.errormorepassenger': 'You chose more passenger ',
  'booking.passengertypeerror': 'Invalid passenger type',
  'booking.chooseallpassenger': 'Please choose all passengers',
  'booking.checkpassport':
    'After uploading passport data, please check your information.',
  'booking.apply': 'apply',
  'booking.flightinformation': 'Flight information',
  'booking.adultticketprice': 'Adult price',
  'booking.childticketprice': 'Child price',
  'booking.infantticketprice': 'Infant price',
  'booking.airplane': 'Airplane',
  'booking.time': 'Depart time',
  'booking.invoiceno': 'Invoice No',
  'booking.charter': 'Charter',
  'booking.systemic': 'Systemic',
  'booking.type': 'Type',
  'booking.paymentprice': 'Payment price',
  'booking.pnrcode': 'PNR',
  'booking.selectpayment': 'Plesae select payment type',
  'booking.temporaryreservation': 'Reservation',
  'booking.direction': 'Direction',
  'booking.passengercount': 'Passengers count',
  'booking.reservesuccess': 'Your ticket has been book temporarily',
  'booking.passengertotalprice': 'Passengers total price',
  'booking.stopduration': 'Stop duration',
  'booking.invalidbirthdate': 'Invalid birth day',
  'booking.invalidexpireday': 'Invalid passport expire day',
  'booking.fullbirthdate': 'Select birth date completely ',
  'booking.fullexpiredate': 'Select passport expire date completely ',
  'booking.creditpayment': 'Payment from your credit was successful',
  'booking.walletpatment': 'Payment from your wallet was successful',
  'booking.pointpayment': 'Payment from your point was successful',
  'booking.tickettimelimit': 'Ticket time limit',
  'booking.onbehalf': 'On behalf',
  'booking.expirereserve': 'Expired',
  'booking.person': 'Person',
  'booking.startorderdate': 'Start Order Date',
  'booking.endorderdate': 'End Order Date',
  'booking.missflight': 'Missed the flight',
  'booking.multiairline': 'Multi airline',
  'booking.in': 'in',
  'booking.afterdiscount': 'After discount',
  'booking.editissuer': 'Issure contact info',
  'booking.referencenumber': 'PNR',
  'booking.train': 'Train',
  'booking.bus': 'Bus',
  'booking.economy': 'Economy',
  'booking.business': 'Bussiness',
  'booking.first': 'First',
  'booking.allcabinclasses':
    'All flight classes will be displayed on your selected route.',
  'booking.findtrip': 'Find Trip',
  'booking.selectacity': 'Select a city',
  'booking.destinations': 'Destinations',
  'booking.london': 'London',
  'booking.rome': 'Rome',
  'booking.istanbul': 'Istanbul',
  'booking.deletePassengerTitle': 'Delete Passenger',
  'booking.invalidnationalcode': 'Invalid National Code',
  'booking.showgatewayerror': 'show gateway error',
  'booking.alternativefrom': 'From',
  'booking.alternativeto': 'To',
  'booking.commingsoon': 'Comming Soon',
  'booking.searchorigin': 'Search Origin',
  'booking.searchdestination': 'Search Destination',
  'booking.plannedflight': 'Your selected flight',
  'booking.yesterday': 'Yesterday',
  'booking.twodaysago': 'Two Days Ago',
  'booking.englishname': 'First Name (English)',
  'booking.englishlastname': 'Last Name (English)',
  'booking.rialtotalprice': 'Total Price(Rial)',
  'booking.gotosearchflight': 'Go to search flight',
  'booking.seat': 'seat',
  'booking.englishticket': 'English version of ticket',
  'booking.persianticket': 'Persian version of ticket',
  'booking.searchmypassenger': 'Search previous passengers',
  'booking.selectairporterror': 'Select origin and destination from above',
  'booking.providergateway': 'Provider gateways',
  'booking.noresultwithfilter':
    'No result found with selected filter,please change it',
  'booking.expirereservation': 'Expired',
  'booking.unpaidreservation': 'Unpaid',
  'booking.selectbooking': 'Please select tickets for pay',
  'booking.mobileformaterror': 'Mobile format is invalid',
  'booking.poweredby': 'Powered by',
  'booking.hoteldescription': 'Book your hotel now with 30% discount',
  'booking.tourdescription':
    '21-day European tour for Nowruz 1401. Registration until the end of December 5% discount',
  'booking.parishotel': 'Paris Hotel',
  'booking.tickettitle': 'Ticket :',
  'booking.stopdurationin': 'Stop duration in',
  'booking.contactInfo': 'Issure contact info',
  'booking.expireDate': 'Expire Date',
  'booking.pnrdesc': 'Book in Amadeus and issue here.',
  'booking.officeid': 'Office Id',
  'booking.pnrhelp': 'User Manual',
  'booking.ticketinfo': "Ticket's Details",
  'booking.saletotalamount': 'Sale Total Amount',
  'booking.traveldatetime': 'Travel Date Time',
  'booking.sale': 'Sale',
  'booking.buy': 'Buy',
  'booking.emailticket': 'Email ticket',
  'booking.changeticketprice': 'Change price',
  'booking.backpreviouspage': 'Return to previous page',
  'booking.changecabinclass': 'Change cabin class',
  'booking.changecabinclassnotify':
    'If you change cabin class in this step you will go back to search flight step!!!!',
  'booking.ticketprice': 'Ticket Price',
  'booking.payableamount': 'Payable Amount',
  'booking.showflight': 'Show flight',
  'booking.tripdirection': 'Trip direction',
  'booking.selectpaymenttype': 'Select payment type',
  'booking.title': 'title',
  'booking.yourchoice': 'Your choice',
  'booking.mr': 'Mr.',
  'booking.mrs': 'Mrs.',
  'booking.result': 'Result',
  'booking.changeflight': 'change flight route',
  'booking.flightOrigin': 'Flight From Origin',
  'booking.flightDestination': 'flight To Destination',
  'booking.originCity': 'Origin City',
  'booking.destinationCity': 'Destination City',
  'booking.welcometripsi': 'Welcome To Tripsi',
  'booking.welcometripord': 'Welcome To Tripord',
  'booking.reservation': 'A temporary reservation is possible for this flight',
  'booking.arrivetime': 'Arrive time',
  'booking.sortbyarrivetime': 'Sort by arrive time',
  'booking.sortbyduration': 'Sort by duration',
  'booking.tickettype': 'Ticket type',
  'bookking.tehran': 'Tehran',
  'booking.mashhad': 'Mashhad',
  'booking.mastercard': 'Master Card',
  'booking.debitCard': 'Debit Card',
  'booking.selectall': 'Select All',
  'booking.addpassenger': 'Add Passenger',
  'booking.textpassenger':
    'Through the form below, you can enter the information of your passenger and register the information at the end. ',
  'booking.loading': 'Loading...',
  'booking.showavailableflight': 'Show available flights',
  'booking.roomtype': "Room's Type",
  'booking.numberofrooms': 'Number of rooms',
  'booking.addnewroom': 'Number of rooms',
  'booking.picturesofroom': 'Pictures of the room',
  'booking.availsflight': 'Avails flight',
  'booking.events': 'Calendar Events ',
  'booking.eventsinfo': "View event's by country",
  'booking.want': 'I wanna',
  'booking.setmaxprice': 'Set Max Price',
  'booking.selectcity': 'Please,select origin and destination airports first',
  'booking.allcabinselected':
    'In domestic flights, all flight classes will be searched',
  'booking.all': 'All',
  'booking.extrabed': 'extera beds',
  'booking.passportImage': 'Passport Image',
  'booking.passporthint':
    'Please upload the image clearly and according to the sample in size 700*500',
  'booking.showsample': 'view sample passport',
  'booking.reservebefore': 'this flight reserve for you before',
  'booking.editpassengersinfo': 'Edit Passengers information',
};
